import React from "react";

const CupTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">NASCAR CUP SERIES STATS, DRIVER, TRACK, OWNER, MANUFACTURER STATS</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">NASCAR Cup Series Stats: The NASCAR Cup Series was formerly known as Strictly Stock (1949), Grand National (1950-1970), Winston Cup Grand National (1971-1985), Winston Cup (1986-2003), Nextel Cup (2004-2007), Sprint Cup (2008-2016) and the Monster Energy NASCAR Cup Series (2017-2019).</p>

       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Champion
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Car Owner
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Champion's Crew Chief
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Rookie of the Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Most Popular Driver
                </th>
                <th scope="col" style={{ textAlign: "center", width: "15%" }}>
                Manufacturers' Championship
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
          
            </tbody>
          </table>
      
        </div>
      </section>
    </>
  );
};

export default CupTable;
